// extracted by mini-css-extract-plugin
export default {"container":"sidebar-menu_container__0z2-3","lang_mobile":"sidebar-menu_lang_mobile__zPjSQ","lang":"sidebar-menu_lang__G1wWt"};